module.exports = {
    setAllJobs: (state, arr) => {
      state.jobs = arr
    },
    setJobsFiltered: (state, arr) => {
      state.jobsFiltered = arr
    },
    setDepartment: (state, value) => {
      state.selectedDepartment = value
    },
    setLocation: (state, value) => {
      state.selectedLocation = value
    },
    setJobType: (state, value) => {
      state.selectedJobType = value
    },
    setDepartmentsFiltered: (state, value) => {
      state.departmentsFiltered = value
    },
    setLocationsFiltered: (state, value) => {
      state.locationsFiltered = value
    },
    setJobTypesFiltered: (state, value) => {
      state.jobTypesFiltered = value
    },
  }